import {ReviewStatusOneviewEnum} from '../../schema-types/globalTypes';

export const formatStage = (stage: ReviewStatusOneviewEnum): string => {
  return stage
    .toLowerCase()
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
